import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-summary-page',
  standalone: false,
  template: '<axis-order-summary [orderData]="orderData"></axis-order-summary>',
})
export class OrderSummaryPageComponent {
  orderData: any;

  constructor(private router: Router) {
    const nav = this.router.currentNavigation();
    this.orderData = nav?.extras?.state?.['orderData'];
  }
}
